/**
 * Adjectives & adverbs: translations, plus the irregular comparison where one
 * exists. gut → besser → am besten is worth a line; schnell → schneller is not,
 * so regular forms are left null and the block does not render.
 */
import { TranslationCardBack } from '@/components/practice/TypeTranslationCard';
import type { AdjectivePayload } from '@/core/types';

import type { CardBackProps } from '../types';

export function CardBack(props: CardBackProps<AdjectivePayload>) {
  const { comparative, superlative } = props.card.payload;
  const forms: [string, string | null][] = [
    ['Komparativ', comparative],
    ['Superlativ', superlative],
  ];
  const present = forms.filter(([, v]) => v);
  return (
    <TranslationCardBack
      {...props}
      nextLabel="Next word"
      headword={props.card.de}
      detail={
        present.length > 0 ? (
          <dl className="bg-muted/40 flex flex-wrap gap-x-6 gap-y-1 rounded-md p-3 text-sm">
            {present.map(([label, value]) => (
              <div key={label} className="flex items-baseline gap-2">
                <dt className="text-muted-foreground text-xs tracking-wide uppercase">{label}</dt>
                <dd className="font-medium">{value}</dd>
              </div>
            ))}
          </dl>
        ) : null
      }
    />
  );
}
